import { EntityService } from 'src/app/services/entity/entity.service';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SessionBusiness } from 'src/app/core/_config/sessionBusiness.service';
import { DropDown } from 'src/app/models/dropDown';
import { SimpleListConfig } from 'src/app/models/simpleListConfig';
import { LoaderService } from 'src/app/core/_config/loader.service';
import { Subject } from 'rxjs';
import { NotificationsService } from 'angular2-notifications';
import { FinancialAgreementService } from 'src/app/services/financial-agreement.service';
import { BugsService } from '../services/bugs.service';
import { BugModel } from '../models/bugModel';
import { BugInputModel } from '../models/bugInputModel';
import { FinancialAgreement } from '../../file-remitance/models/financialAgreement';

@Component({
   selector: 'kt-manage-bugs',
   templateUrl: './manage-bugs.component.html',
   styleUrls: ['./manage-bugs.component.css'],
})
export class ManageBugsComponent implements OnInit {
   constructor(
      private cdref: ChangeDetectorRef,
      private bugsService: BugsService,
      private entityService: EntityService,
      private sessionBusiness: SessionBusiness,
      private loaderService: LoaderService,
      private notificationsService: NotificationsService,
      private financialAgreementService: FinancialAgreementService,
      private fb: FormBuilder,
      iconRegistry: MatIconRegistry,
      sanitizer: DomSanitizer,
   ) {
      iconRegistry.addSvgIcon(
         'file',
         sanitizer.bypassSecurityTrustResourceUrl('assets/media/svg/icons/Files/File.svg'),
      );
      this.getFinancialAgreements();
      this.createForm();
   }

   resOk: boolean = false;
   searchParams: any;
   entityAgreements: FinancialAgreement[];
   agreementLoading: boolean = false;
   successMessage: string;
   showAlert = false;
   bugsForm: FormGroup;
   selectedLines: BugModel[] = [];
   hasSelectedAll: boolean = false;
   eventSelectAll: Subject<void> = new Subject<void>();
   simpleTableConfig: SimpleListConfig = {
      useSortable: true,
      useFilter: false,
      usePagination: true,
      page: {
         index: 0,
         size: 0,
         totalElements: 0,
      },
      pageSize: [10, 20],
      dateformat: 'dd/MM/yyyy',
      displayColumns: [
         {
            displayName: 'Nº Fatura',
            field: 'billetNumber',
         },
         {
            displayName: 'Vencimento',
            field: 'atMaturity',
            type: 'date',
         },
         {
            displayName: 'Data de Retorno',
            field: 'returnDate',
            type: 'date',
         },
         {
            displayName: 'Mensagem',
            field: 'message',
            type: 'messageTooltip',
         },
      ],
      selection: {
         type: 'multiple',
      },
   };

   //DataSource
   dataSource: BugModel[] = [];
   entityId: string = this.sessionBusiness.EntityIdContext;
   name: string = '';

   //Paginação
   limit: number = 10;
   skip: number = 1;

   createForm() {
      this.bugsForm = this.fb.group({
         entity: new FormControl(null, Validators.compose([Validators.required])),
         agreement: new FormControl(null, Validators.compose([Validators.required])),
      });
   }

   ngOnInit() {
      this.searchParams = {
         params: {
            limit: this.simpleTableConfig.pageSize[0],
            skip: 0,
         },
      };
   }

   getBugsByLegalEntity(params: any) {
      params = {
         totalItemByPage: this.limit,
         currentPage: this.skip,
         financialAgreementId: this.bugsForm.value.agreement.financialAgreementId,
      };
      this.resOk = false;
      this.cdref.detectChanges();

      this.bugsService.getErrorItemsLegalEntity(params).subscribe((res) => {
         this.simpleTableConfig.page.index = res.data.currentPage - 1;
         this.simpleTableConfig.page.totalElements = res.data.totalRecords;

         if (res.data.totalRecords > this.simpleTableConfig.pageSize[2]) {
            let index = this.simpleTableConfig.pageSize.indexOf(res.data.totalRecords);

            if (index === -1) {
               this.simpleTableConfig.pageSize.push(res.data.totalRecords);
            }
         }

         this.dataSource = res.data.result;
         this.loaderService.hide();
         this.resOk = true;
         this.reset();
         this.cdref.detectChanges();
      });
   }

   generateFileProcess() {
      this.resOk = false;
      this.loaderService.show();
      this.cdref.detectChanges();

      var generateFile: BugInputModel = {
         financialAgreementId: this.bugsForm.value.agreement.financialAccountId,
         lines: this.selectedLines,
      };

      this.bugsService.generateFileProcess(generateFile).subscribe({
         next: (res) => {
            if (res.message) {
               this.successMessage = `${res.message}`;
               this.showAlert = true;
               setTimeout(() => (this.showAlert = false), 30000);
            }
            this.reset();
            this.search();
         },
         error: (err) => {
            //this.notificationsService.error(`${err.message}`);
            this.resOk = true;
            this.loaderService.hide();
            this.cdref.detectChanges();
         },
      });
   }

   resSelectedLines(event) {
      this.selectedLines = event;
   }

   reset() {
      this.selectedLines = [];
      this.hasSelectedAll = false;
      this.cdref.detectChanges();
   }

   selectAll() {
      this.hasSelectedAll = !this.hasSelectedAll;
      this.eventSelectAll.next();
   }

   search() {
      this.searchParams = {
         params: {
            skip: 0,
            limit: this.simpleTableConfig.pageSize[0],
         },
      };

      if (this.bugsForm.value.agreement.financialAccountId != null) {
         this.searchParams.params.financialAgreementId = this.bugsForm.value.agreement.financialAccountId;
      }

      this.getBugsByLegalEntity(this.searchParams);
   }

   getFinancialAgreements() {
      this.agreementLoading = true;
      this.financialAgreementService.getFinancialAgreements().subscribe((res) => {
         this.entityAgreements = res.data;
         this.agreementLoading = false;
         this.cdref.detectChanges();
      });
   }

   reloadingForAction(ev) {
      this.searchParams.params.skip = ev.pageIndex * ev.pageSize;
      this.searchParams.params.limit = ev.pageSize;
      this.simpleTableConfig.page.size = ev.pageSize;
      this.skip = ev.pageIndex + 1;
      this.limit = ev.pageSize;

      this.getBugsByLegalEntity(this.searchParams);
   }
}
